import React from 'react';
import { useAuth } from '../../context/AuthContext';
import PortalLayout from './PortalLayout';
import ChecklistPanel from '../../components/portal/ChecklistPanel';
import { Loader2 } from 'lucide-react';

const PortalChecklist = () => {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <PortalLayout activeTab="checklist">
        <div className="min-h-screen bg-[#F9F6EF] flex items-center justify-center">
          <Loader2 className="w-8 h-8 text-[#2CA8A0] animate-spin" data-testid="checklist-loading" />
        </div>
      </PortalLayout>
    );
  }

  return (
    <PortalLayout activeTab="checklist">
      <div className="min-h-screen bg-[#F9F6EF] p-4 sm:p-6 lg:p-12">
        {user ? <ChecklistPanel showHeader emptyMessage="Your checklist will appear here once your Blueprint is generated." /> : null}
      </div>
    </PortalLayout>
  );
};

export default PortalChecklist;
